module.exports = __webpack_public_path__ + "static/media/jetsuite_card_2.1529aa41.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/jetsuite_card_2.png
// module id = 515
// module chunks = 0